

const ehliyetOptions = [
    {
        value: "B",
        text: "B: Otomobil-Kamyonet",
        id:  "B"
    },
    {
        value: "BE",
        text: "BE: Römorklu Otomobil-Kamyonet",
        id:  "BE"
    },
    {
        value: "C1",
        text: "C1: 7,5 Tona Kadar Kamyon-Çekici",
        id:  "C1"
    },
    {
        value: "C",
        text: "C: Kamyon-Çekici",
        id:  "C"
    },
    {
        value: "CE",
        text: "CE: Römorklu Kamyon-Çekici",
        id:  "CE"
    },
    {
        value: "D",
        text: "D: Minibüs-Otobüs",
        id:  "D"
    },
    {
        value: "DE",
        text: "DE: Römorklu Minibüs-Otobüs",
        id:  "DE"
    },
    {
        value: "G",
        text: "G: İş Makinesi",
        id:  "G"
    },

]



const SRCTypeOptions = [
    {
        value: "SRC1",
        text: "SRC1: Uluslararası Yolcu Taşıma",
        id:  "SRC1"
    },
    {
        value: "SRC2",
        text: "SRC2: Yurtiçi Yolcu Taşıma",
        id:  "SRC2"
    },
    {
        value: "SRC3",
        text: "SRC3: Uluslararası Yük Taşıma",
        id:  "SRC3"
    },
    {
        value: "SRC4",
        text: "SRC4: Yurtiçi Yük Taşıma",
        id:  "SRC4"
    },
    {
        value: "SRC5",
        text: "SRC5 (ADR): Tehlikeli Madde Taşıma",
        id:  "SRC5"
    },
]



export {ehliyetOptions, SRCTypeOptions}